//@ts-nocheck
/* eslint no-unused-vars: 0 */

import React, { Component } from 'react'
import T from 'prop-types'

import { Events } from 'constants/event'
import withEventEmitter from '../../hoc/withEventEmitter'
import { Button } from '@wework/dieter-ui'
import {
  RotateLeftIcon,
  RecenterIcon,
  RotateRightIcon,
  MapLegendIcon,
} from 'components/Icons'

class MapLegendAndControl extends React.PureComponent<any, any> {
  componentDidUpdate(prevProps) {
    const { buildingId } = this.props
    if (prevProps.buildingId !== buildingId) {
      // eslint-disable-next-line react/no-did-update-set-state
      // this.setState({ showLegend: false })
    }
  }

  toggleLegend() {
    const { emitUserEvent, onLegendToggle, showLegend } = this.props
    emitUserEvent(
      showLegend ? Events.TOGGLE_LEGEND_HIDE : Events.TOGGLE_LEGEND_SHOW,
      {}
    )
    onLegendToggle()
  }

  render() {
    const { disabled } = this.props
    return (
      // <div className={`${classes.mw_legend_container} my-seventh-step`}>
      <div>
        {/* Legend */}

        <Button
          default
          style={{ marginRight: 16 }}
          // className={showLegend ? classes.offButton : classes.onButton}
          onClick={() => {
            this.toggleLegend()
          }}
          icon={<MapLegendIcon color="gray" />}
        />

        {/* Rotation */}

        <Button
          icon={<RotateRightIcon color="gray" />}
          onClick={() => {
            // if (window.__fm.sceneRotationAngle <= -360) {
            //   window.__fm.sceneRotationAngle = 0
            // }
            // window.__fm.sceneRotationAngle -= 90
            const { onRotate, emitUserEvent } = this.props
            onRotate(90)
            emitUserEvent(Events.ROTATE_MAP_CLOCKWISE, {})
          }}
          disabled={disabled}
        />

        <Button
          onClick={() => {
            const { onResetCamera, emitUserEvent } = this.props
            onResetCamera()
            emitUserEvent(Events.RESET_CAMERA, {})
          }}
          disabled={disabled}
          default
          icon={<RecenterIcon color="gray" />}
        />
        <Button
          icon={<RotateLeftIcon color="gray" />}
          // className={classes.onButton}
          onClick={() => {
            const { onRotate, emitUserEvent } = this.props
            onRotate(-90)
            emitUserEvent(Events.ROTATE_MAP_ANTI_CLOCKWISE, {})
          }}
          disabled={disabled}
        />
      </div>
    )
  }
}

export default withEventEmitter()(MapLegendAndControl)
